import { useState } from 'react';
import { PrismicRichText } from '@prismicio/react';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

import {
  Accordion,
  AccordionItem,
  AccordionTitle,
  AccordionBody,
  IconWrapper,
} from 'common/components/Accordion';
import {
  FaqQuestion,
  FaqWrapper,
  FaqAnswer,
  ChildFaq,
  StyledTitle,
  StyledLink,
} from './NewFaq.style';
import Container from 'common/components/Container';
import { ContainerButton } from '../TransformationStep/TransformationStepStyle';
import { PrimaryButton } from '../Banner/banner.style';
import Link from 'next/link';
const NewFaqSection = ({ slice }) => {
  const [activeIndex, setActiveIndex] = useState(0);

  return (
    <Container>
      <PrismicRichText
        field={slice.primary.headline}
        components={{
          paragraph: ({ children }) => (
            <StyledTitle variant="h2">{children}</StyledTitle>
          ),
        }}
      />
      <ChildFaq>
        <Accordion>
          <FaqWrapper>
            {slice.items.map((accordionItem, index) => (
              <AccordionItem
                className={`accordion_item ${index === activeIndex ? 'active' : ''}`}
                key={`accordion-${index}`}
                expanded={index === activeIndex}
                onClick={() =>
                  setActiveIndex(activeIndex === index ? -1 : index)
                }
              >
                <>
                  <AccordionTitle className="accordion_title">
                    <>
                      <FaqQuestion variant="h3">
                        <PrismicRichText field={accordionItem.title} />
                      </FaqQuestion>
                      <IconWrapper>
                        <ExpandMoreIcon
                          style={{
                            transform:
                              activeIndex === index
                                ? 'rotate(180deg)'
                                : 'rotate(0deg)',
                            transition: 'transform 0.3s ease',
                          }}
                        />
                      </IconWrapper>
                    </>
                  </AccordionTitle>
                  <AccordionBody className="accordion_body">
                    <FaqAnswer>
                      <PrismicRichText field={accordionItem.description} />
                    </FaqAnswer>
                  </AccordionBody>
                </>
              </AccordionItem>
            ))}
          </FaqWrapper>
        </Accordion>
      </ChildFaq>
      {slice.primary.cta_demo && slice.primary.link_demo && (
        <ContainerButton>
          <Link
            href={slice.primary.link_demo}
            passHref
            legacyBehavior
            sx={{ textDecoration: 'none' }}
          >
            <PrimaryButton>{slice.primary.cta_demo}</PrimaryButton>
          </Link>
        </ContainerButton>
      )}
    </Container>
  );
};

export default NewFaqSection;
